import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from '../component/Header';
import SideBar from '../component/SideBar';
import Actions from '../redux/actions';
import AppLoader from '../utils/AppLoader';
import PaginationComponenent from '../component/Pagination';
import Constants, { LIMIT, THREEDSCRIPT } from '../utils/Constants';
import { toast } from 'react-toastify';
import RoutePath from '../utils/routes/RoutePath';
import VendorRoomService from '../component/VendorRoomService';
import { getSavedPage, setSavedPage } from '../utils/paginationState';

const PAGINATION_KEY = 'vendor-room-service-list';

class VendorRoomServiceList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pageNumber: getSavedPage(PAGINATION_KEY),
            totalItem: '',
            isVendor: false,
            isCopied: false,
            searchText: '',
        }
    }
    componentDidMount() {
        const Agent = this.props.match.path.split('/')
        if (Agent[2] === "products" && Agent[1] === "admin") {
            this.setState({ isVendor: true })
        } else {
            this.setState({ isVendor: false })
        }
        this.getVendorAllRoomServiceList()
    }

    getVendorAllRoomServiceList = () => {
        let params = {
            limit: LIMIT,
            pageNumber: this.state.pageNumber - 1
        }
        const callback = (response) => {
            if (response) {
                this.setState({ totalItem: response.response.totalItems })
            }
        }
        this.props.getVendorRoomServiceList(params, callback, false)
    }
    onChangePagination = (pageNumber) => {
        let params = {
            pageNumber: (pageNumber - 1),
            limit: LIMIT
        }
        this.props.getVendorRoomServiceList(params, '', false)
        setSavedPage(PAGINATION_KEY, pageNumber);
        this.setState({ pageNumber: pageNumber })
    }
    updateStatus = (id, active) => {
        const updateParams = {
            id,
            isActive: active ? 0 : 1
        }
        const callback = (response) => {
            if (response.response_code === 0) {
                toast.success(Constants.UPDATED_SUCCESSFULLY)
                this.getVendorAllRoomServiceList()
            }
            else {
                toast.error(response.response_message)
            }
        }
        this.props.updateVendorRoomService(updateParams, callback, false)
    }
    addVendorRoomService = () => {
        this.props.history.push(RoutePath.VENDOR_ROOM_SERVICE_ADD)
    }
    // // onClick handler function for the copy button
    handleCopyClick = async (copyText) => {
        navigator.clipboard.writeText(copyText);
        this.setState({ isCopied: true })
    }
    clearSearch = () => {
        this.setState({ searchText: '' })
    }
    handleSearchChange = (e) => {
        this.setState({ searchText: e.target.value, pageNumber: 1 })
    }
    render() {
        const { pageNumber, isVendor, searchText } = this.state;
        const { getVendorRoomService = {} } = this.props
        const { isLoading, vendorRoomServiceListData } = getVendorRoomService
        const search = (searchText || "").trim().toLowerCase();
        const filteredMappings = (vendorRoomServiceListData?.roomMappings || []).filter((item) => {
            if (!search) return true;
            const roomId = String(item?.SrmIpRoom?.patientRoomId || "").toLowerCase();
            const roomName = (item?.SrmIpRoom?.patientRoomName || "").toLowerCase();
            const serviceName = (item?.SrmIpServiceMaster?.serviceName || "").toLowerCase();
            const agentEmail = (item?.User?.email || "").toLowerCase();
            return roomId.includes(search) || roomName.includes(search) || serviceName.includes(search) || agentEmail.includes(search);
        });
        return (
            <div className="dashboard-screen-part">
                <div className="d-flex p-0">
                    <SideBar />
                    <div className="card-right p-0">
                        <Header />
                        <div className='addButton'>
                            <div className="add-btn">
                                <button className="btn add-item" type="button" onClick={() => this.addVendorRoomService()}><i className="fa-solid fa-plus me-3"></i>Add Room Service</button>
                            </div>
                            <div className="add-btn search-box">
                                <input
                                    className="form-control search-input"
                                    placeholder="Search room id / room / service / email"
                                    value={searchText}
                                    onChange={this.handleSearchChange}
                                />
                                {searchText ? <button type="button" className="search-clear-btn" onClick={this.clearSearch}>x</button> : null}
                            </div>
                        </div>
                        <VendorRoomService roomServiceList={filteredMappings} updateStatus={(id, active) => this.updateStatus(id, active)}
                            isVendor={isVendor}
                            currentPage={pageNumber} />
                        <div className='page-content'>
                            {
                                vendorRoomServiceListData?.totalItems > (LIMIT - 1) ? <PaginationComponenent currentPage={pageNumber} countValue={vendorRoomServiceListData?.totalItems} onChangeHandle={this.onChangePagination} /> : ''
                            }
                        </div>
                    </div>
                </div>

                {isLoading && <AppLoader />}
            </div>
        );
    }
}

export const mapStateToProps = (state) => {
    return {
        getVendorRoomService: Actions.getVendorRoomService(state)
    }
};
export default withRouter(connect(mapStateToProps, {
    getVendorRoomServiceList: Actions.getVendorRoomServiceList,
    updateVendorRoomService: Actions.updateVendorRoomService
})(VendorRoomServiceList
));